module.exports = __webpack_public_path__ + "img/03_office_employee_avatar_man_chart_graph_presentation-256.929aef3f.png";